module.exports = __webpack_public_path__ + "img/tylenol_cold_flu_severe_for_day_night.42ba1daf.jpg";